import { apiUrl } from "../../../../Constant/apiConstant"
import { getRequest, postJsonRequest } from "../../../../service/apiService"

export const getPanelAndStakeholdersDropdown = async (tenant: string | undefined) => {
    try{
        const response = await getRequest(apiUrl.UM_GET_PANEL_AND_STAKEHOLDERS_DROPDOWN,{},tenant,true)

        if(response.status === 200){
            const {Status,Data}=response.data
             return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }
    return []
}

export const addPanelAndStakeholder = async (formData: any, tenant: string | undefined) => {
    try {
       const response = await postJsonRequest(apiUrl.UM_POST_ADD_PANEL_AND_STAKEHOLDER,formData,tenant,true)
       if(response.status === 200){
         const {Status,Message,ParticipantID} = response.data
         return {Status, Message, ParticipantID}
       }
    } catch (error) {
        console.log(error)
    }
    return null;
}

export const getPanelAndStakeholders = async (tenant: string | undefined,payLoad:any) => {
    try {
        const response = await postJsonRequest(apiUrl.UM_GET_PANEL_AND_STAKEHOLDERS,payLoad,tenant,true)
        if(response.status === 200){
            const {Status,Data,TotalCount} = response.data
            return Status ? {Data,TotalCount} : null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deletePanelOrStakeholder =async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_DELETE_PANEL_OR_STAKEHOLDER,payLoad,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}